import { render, staticRenderFns } from "./geographyTab.vue?vue&type=template&id=53c9afda&scoped=true&"
import script from "./geographyTab.vue?vue&type=script&lang=js&"
export * from "./geographyTab.vue?vue&type=script&lang=js&"
import style0 from "./geographyTab.vue?vue&type=style&index=0&id=53c9afda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9afda",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QSelect,QInput})
